import { getCookies } from 'cookies-next';
import axios from '../axios-config';

/*
===============================|> All Cart APis <|===============================
01 |--> create cart,
02 |--> get cart,
03 |--> add item to cart,
04 |--> add bundle products to cart,
05 |--> update cart item,
06 |--> delete cart item,
07 |--> Aapply coupon,
08 |--> delete coupon,
09 |--> merge guest cart
10 |--> add product fees
11 |--> delete product fees
12 |--> validate voucher coupon
13 |--> apply voucher coupon
14 |--> clear cart if region changed
15 |--> check if all cart items available to checkout
===============================|> All Cart APis <|===============================
*/

// 01- ============= create cart
const createCart = async ({ mage }) => {
  let config = {
    method: 'post',
    url: '/cart/create',
    headers: {
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 02- =============  get cart
const getCart = async ({ mage, quote, handshake }) => {
  let config = {
    method: 'get',
    url: '/cart/details/total',
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
      ...(handshake ? {Authorization: 'Bearer ' + handshake} : {})
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 03- ============= Add item to cart

const addItemToCart = async ({
  mage,
  quote,
  sku,
  qty,
  configurable_item_options,
}) => {
  let data = {
    cartItem: {
      sku,
      qty: qty,
      quote_id: quote,
      ...(Object.keys(configurable_item_options || {})?.length
        ? {
            product_option: {
              extension_attributes: {
                configurable_item_options,
              },
            },
          }
        : {}),
    },
  };

  let config = {
    method: 'post',
    url: '/cart/add/items/v2',
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify(data),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 04- ============= Add multi items to cart
const addMultiItemsToCart = async (mage, quote, skus) => {
  // const cartItems = skus.map((sku) => ({
  //   sku,
  //   qty: 1,
  // }));
  let config = {
    method: 'post',
    url: '/cart/multi/items',
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify({ cartItems: skus }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 05- ============= Update cart item
const updateCartItem = async (item_id, qty, mage, quote) => {
  let config = {
    method: 'put',
    url: `cart/update/items/${item_id}`,
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify({
      cartItem: { qty, item_id },
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 06- ============= Delete cart item
const deleteCartItem = async (item_id, mage, quote) => {
  let config = {
    method: 'delete',
    url: `cart/delete/items/${item_id}`,
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 07- ============= Apply coupon code
const applyCoupon = async (mage, quote, couponCode) => {
  let config = {
    method: 'put',
    url: `/customer/applyCoupon/${couponCode}`,
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 08- ============= Delete coupon
const deleteCoupon = async (mage, quote) => {
  let config = {
    method: 'delete',
    url: '/customer/deleteCoupon',
    headers: {
      quote: 'Bearer ' + quote,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 09- ============= merge guest user cart to logged in user cart
const mergeMaskedCart = async (mage, quote, storeId, customerId) => {
  let config = {
    method: 'put',
    url: '/cart/mergeQuote/' + quote,
    headers: {
      mage: 'Bearer ' + mage,
    },
    data: JSON.stringify({ customerId, storeId }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 15- Rajhi Get Otp
const rajhiGetOtp = async (mobile_number) => {
  let config = {
    method: 'post',
    url: `/mokafa/get-otp?mobile=${mobile_number}`,
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 16- Rajhi Reedem
const rajhiRedeem = async (mobile, amount, pin, quoteId, referenceId) => {
  let config = {
    method: 'post',
    url: '/mokafa/applypoint',
    data: JSON.stringify({
      mobile,
      amount,
      pin,
      quoteId,
      isMask: true,
      referenceId,
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const addProductFees = async (itemId, product_fees) => {
  const { handshake, quote, mage } = getCookies();
  const multipleData = {};
  product_fees.forEach((obj) => {
    const key = Object.keys(obj)[0];
    const data = obj[key];
    multipleData[data.id] = {
      id: parseInt(data.id),
      options: parseInt(data.options),
    };
  });

  let config = {
    method: 'post',
    url: `/fees/add-product-fees`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      quote: `Bearer ${quote}`,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify({
      feeData: { itemId, multipleData },
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 14- ============= active cart
const deleteProductFee = async (id, itemId) => {
  const { handshake, quote, mage } = getCookies();
  let config = {
    method: 'post',
    url: `/fees/remove-product-fees`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      quote: `Bearer ${quote}`,
      ...(mage ? { mage: `Bearer ${mage}` } : {}),
    },
    data: JSON.stringify({ feeData: { id, itemId } }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 15 Send Gift Options
const sendGiftOptions = async (values, is_user) => {
  const { quote } = getCookies();
  let config = {
    method: 'POST',
    url: '/quote-attributes/gift',
    headers: { quote: `Bearer ${quote}` },
    data: JSON.stringify({
      cart_id: quote,
      is_guest: is_user ? false : true,
      has_gift: 1,
      ...values,
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const sendVoucherMobile = async (phone) => {
  let config = {
    method: 'POST',
    url: '/customer/pg-send-otp',
    data: JSON.stringify({
      phone: '00966'.concat(phone.slice(-9)),
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const sendEvoucherData = async (voucher, phone, isMask, otp) => {
  const { quote } = getCookies();
  let config = {
    method: 'POST',
    url: '/customer/redeem',
    data: JSON.stringify({
      cartId: quote,
      isMask,
      voucher,
      phone: '00966'.concat(phone.slice(-9)),
      otp,
    }),
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// export all functions
export {
  createCart,
  getCart,
  addItemToCart,
  addMultiItemsToCart,
  updateCartItem,
  deleteCartItem,
  applyCoupon,
  deleteCoupon,
  mergeMaskedCart,
  rajhiGetOtp,
  rajhiRedeem,
  addProductFees,
  deleteProductFee,
  sendGiftOptions,
  sendVoucherMobile,
  sendEvoucherData,
};
